import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectCurrentRoom } from '@store/actionSlices/appConfig'
import { TokenInterface } from '@store/actionSlices/token'

import { Status } from '@components/data-handler/data-handler'

import {
  selectShowcaseRoomConfigFromResult,
  useGetShowcaseRoomConfigQuery,
} from '@api/showcase-room'

import { hasToken } from '@adUtilities/token-helper'

interface Props {
  projectName: string
  token: TokenInterface
}

const useGetShowcaseRoomsConfig = ({ projectName, token }: Props) => {
  const isAuthenticated = useMemo(() => hasToken(token), [token])
  const currentRoom = useSelector(selectCurrentRoom)

  const {
    isLoaded: isShowcaseRoomConfigLoaded,
    isError: hasShowcaseRoomConfigError,
    showcaseRoomConfig,
    status: showcaseRoomConfigStatus,
  } = useGetShowcaseRoomConfigQuery(
    {
      projectName,
      showcaseRoomId: currentRoom,
    },
    {
      selectFromResult: selectShowcaseRoomConfigFromResult,
      skip: !currentRoom || !isAuthenticated,
    }
  )

  return {
    isLoaded: isShowcaseRoomConfigLoaded,
    isError: hasShowcaseRoomConfigError,
    showcaseRoomConfig,
    isFulfilled: showcaseRoomConfigStatus === Status.FULFILLED,
  }
}

export default useGetShowcaseRoomsConfig
